import { fromJS } from 'immutable';

import { SET_SELECTED_DATE_RANGE, SET_SAVE_NOTE } from '../../actions/tm/utils';

const initialState = fromJS({
  dateRange: {},
  savedNote: ''
});

export default function utils(state = initialState, action) {
  switch (action.type) {
    case SET_SELECTED_DATE_RANGE:
      return {
        ...state,
        dateRange: action.payload
      };
    case SET_SAVE_NOTE:
      return {
        ...state,
        savedNote: action.payload
      };
    default:
      return {
        ...state
      };
  }
}
